/**
 * Procedencia de la visita, para saber qué campaña acaba en una prueba real
 * del extractor gratuito.
 *
 * El dato hay que capturarlo al ATERRIZAR, no al subir el documento: quien
 * llega desde el cold email a un artículo del blog y desde ahí pasa a `/free`
 * ya ha perdido los `utm_*` de la URL. Por eso se guarda en `sessionStorage`
 * en la primera página vista y se lee después. Dura lo que la pestaña, que es
 * exactamente la ventana en la que la atribución tiene sentido.
 *
 * No se guarda nada identificativo: solo de dónde viene el clic.
 */
const KEY = "ws_attr";

function readStore() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

/** Llamar una vez por carga de página. Idempotente: el primer origen gana. */
export function captureAttribution() {
  if (typeof window === "undefined") return;
  try {
    if (readStore()) return; // el primer toque es el que atribuye
    const p = new URLSearchParams(window.location.search);
    const src = p.get("utm_source") || p.get("src") || p.get("ref");
    const campaign = p.get("utm_campaign");
    if (!src && !campaign) return;
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ src: src || null, campaign: campaign || null })
    );
  } catch {
    // sessionStorage puede estar bloqueado (modo privado, cookies de terceros).
    // No es motivo para romper la página: se pierde la atribución y ya.
  }
}

/** Devuelve `&src=…&utm_campaign=…` listo para concatenar, o cadena vacía. */
export function attributionQuery() {
  const a = readStore();
  // La página desde la que se sube va SIEMPRE, haya o no utm: el `referer` que
  // recibe la API es solo el origen («https://whappscan.com/»), porque la
  // llamada es a otro dominio. Sin esto no sabemos qué página convierte — la
  // primera conversión orgánica (20-9-2026) hubo que rastrearla en GA4.
  const p = new URLSearchParams();
  try {
    if (typeof window !== "undefined") p.set("p", window.location.pathname.slice(0, 120));
  } catch {
    /* sin window no pasa nada */
  }
  if (!a) {
    const q0 = p.toString();
    return q0 ? `&${q0}` : "";
  }
  if (a.src) p.set("src", a.src);
  if (a.campaign) p.set("utm_campaign", a.campaign);
  const q = p.toString();
  return q ? `&${q}` : "";
}
